import { createTheme, Grid, MuiThemeProvider, Typography } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import getDefaultGridOptions from '../../../utils/componentUtils';
import utilsDate from '../../../utils/Date';
import { useStyles } from '../Style';

type props =  any;

const MvmShedList: React.FC<props> = ({ control, title, name, resumido=false, mvmNumber='' }) => {

    const classes = useStyles();
    const { t: tMvm } = useTranslation("Mvm");
    const { t: tMvmShed } = useTranslation("MvmShed");
    const { t: tWindow } = useTranslation("Window");
    const { t: _t } = useTranslation("General");
    const { fields } = useFieldArray({ control, name: name });

    const columns = [
        {
            name: 'shedCode',
            label: tMvm('mvmNumber'),
            options: {
                display: mvmNumber.length > 0,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return mvmNumber;
                }
            }
        },
        {
            name: 'shedCode',
            label: tMvmShed('shed'),
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {

                    var splited = value.split(' - ')
                    return splited[0]
                }
            }
        },
        {
            name: 'shedType',
            label: tMvmShed('type'),
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {

                    return (value == 'D' ? tWindow('unload') : tWindow('load'))
                }
            }
        },
        {
            name: 'movementTypeDescription',
            label: tMvmShed('movementType'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })  
            }
        },
        {
            name: 'checkInDate',
            label: tMvmShed('checkInDate'),
            options: {
                display: !resumido,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTime(value);
                }
            }
        },
        {
            name: 'entryDate',
            label: tMvmShed('entryDate'),
            options: {
                display: !resumido,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTime(value);
                }
            }
        },
        {
            name: 'exitDate',
            label: tMvmShed('exitDate'),
            options: {
                display: !resumido,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTime(value);
                }
            }
        }
    ]

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            }
        }
    })

    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            {!resumido && (
                <Typography className={classes.root} style={{ marginLeft: 0 }} >
                    {title ? title : tMvm("sheds")}
                </Typography>
            )}
            <Typography className={classes.paper} style={{ marginLeft: 0 }} >
                {_t("totalRecords")} {fields ? fields.length : '0'}
            </Typography>
            <MuiThemeProvider theme={myTheme} >
                <MUIDataTable
                    title=""
                    data={fields}
                    columns={columns}
                    options={{
                        ...getDefaultGridOptions(_t),
                        serverSide: false,
                        pagination: false,
                        sortOrder: {
                            name: 'order',
                            direction: 'asc'
                        },
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',
                    }}
                />
            </MuiThemeProvider>
        </Grid>
    )
}

export default MvmShedList